import axios from "axios";

import { sisikong_url } from "..";
import type { GetQuotationrequestResponse } from "./types";

export function getQuotations({
  token,
  params,
}: {
  token: string;
  params: any;
}): Promise<{ data: GetQuotationrequestResponse }> {
  return axios.get(`${sisikong_url}/crs/external/quotationrequest/`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
}
